module.exports = "/assets/site/images/Monautix-Kft.jpg?812268548f3c5a9eb91bf6cefef11031";